import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  &.btn {
    display: flex;

    &.btn_bottom {
      margin: 50px 0;
      text-align: center;
      display: block;
    }

    &.btn_right {
      position: absolute;
      top: 20px;
      right: 15px;
    }

    &.btn_top {
      margin-bottom: 7px;
      text-align: right;
      position: relative;
      display: block;

      > * {
        margin: 1px;
      }
    }
  }
`;

const ButtonWrapDiv = ({ children, className = "", style = {} }) => {
  return (
    <StyledDiv className={`btn ${className}`} style={style}>
      {children}
    </StyledDiv>
  );
};

export default ButtonWrapDiv;
